<template lang="pug">
.modal-card
  header.modal-card-head.px-4.py-3
    p.modal-card-title(data-qa="modal-header") 
      b(v-t="'appointment.abort_title'")
    div
      a.button.is-white.is-small(@click="$emit('close')")
        span.icon
          i.mdi.mdi-close.mdi-24px
  section.modal-card-body
    label.label(v-t="'appointment.abort_reason_heading'")
    select-box(:data="options" v-model="status" )
    hr
    template(v-if="event")
      template(v-if="participation.payment")
        payment-view(:value="participation.payment")
        b-field(:label="$t('appointment.termination.penalty_policy')")
          b-switch(v-model="lateCancel" type="is-danger")
            span(v-if="lateCancel" v-t="'appointment.termination.charge_deposit'")
            span(v-else v-t="'appointment.termination.refund_deposit'")
      template(v-else-if="participation.membership")
        b-field(:label="$t('appointment.termination.applied_memberships')")
          CustomerMembershipTagView(:value="participation.membership")
        b-field(:label="$t('appointment.termination.penalty_policy')")
          b-switch(v-model="lateCancel" type="is-danger")
            span(v-if="lateCancel" v-t="'appointment.termination.penalize_by_one_visit'")
            span(v-else v-t="'appointment.termination.do_not_penalize'")
      template(v-else-if="participation.voucher")
        .tags
          voucher-name-view.tag.is-black(:value="participation.voucher")
        b-field(:label="$t('appointment.termination.penalty_policy')")
          b-switch(v-model="lateCancel" type="is-danger")
            span(v-if="lateCancel" v-t="'appointment.termination.charge_gift_card_balance'")
            span(v-else v-t="'appointment.termination.do_not_charge_gift_card_balance'")
  footer.modal-card-foot
    .buttons 
      action-button.is-danger(title="actions.confirm" @click="submit" :loading="loading")
      button.button(@click="$emit('close')") {{ $t('actions.close') }}
  
</template>

<script>
import {mapActions, mapState} from 'vuex'
import APPOINTMENT_STATUS from '../../../constants/appointmentStatus'
import DEPOSIT_PROCESS_TYPES from '../../../constants/depositProcessTypes'
import CustomerMembershipTagView from '../membership/CustomerMembershipTagView'
import dayjs from 'dayjs'

export default {
  name: 'ParticipationAbortActions',
  components: {
    CustomerMembershipTagView
  },
  props: {
    appointmentId: {type: String, required: true},
    customerId: {type: String, required: true},
    initialStatus: {type: String, default: APPOINTMENT_STATUS.CANCELED}
  },
  data() {
    return {
      loading: false,
      status: APPOINTMENT_STATUS.CANCELED,
      event: undefined,
      lateCancel: false
    }
  },
  computed: {
    ...mapState('company', ['company']),
    isLateCancel() {
      if (this.company.deposit.cancelationPolicy === null) {
        return true
      }
      if (this.company.deposit.cancelationPolicy === -1) {
        return false
      }
      return dayjs(this.event.start)
        .subtract(this.company.deposit.cancelationPolicy, 'minutes')
        .isAfter(new Date())
    },
    participation() {
      return this.event.participants.find(p => p.customer === this.customerId)
    },
    options() {
      return [
        {
          title: this.$t('appointment.actions.cancel'),
          description: this.$t('appointment.cancel_description'),
          value: APPOINTMENT_STATUS.CANCELED
        },
        {
          title: this.$t('appointment.actions.noshow'),
          description: this.$t('appointment.noshow_description'),
          value: APPOINTMENT_STATUS.NOSHOW
        }
      ]
    }
  },
  watch: {
    status(value) {
      if (value === APPOINTMENT_STATUS.NOSHOW) {
        this.lateCancel = this.isLateCancel
      }
    }
  },
  async created() {
    this.event = await this.fetchAppointmentById({id: this.appointmentId})
    this.lateCancel = this.isLateCancel
    if (this.initialStatus) {
      this.status = this.initialStatus
    } else if (new Date(this.event.start) < new Date()) {
      this.status = APPOINTMENT_STATUS.NOSHOW
    }
  },
  methods: {
    ...mapActions('appointments', ['terminateParticipation', 'fetchAppointmentById']),
    submit() {
      if (this.status === APPOINTMENT_STATUS.CANCELED) {
        this.cancelAppointment()
      } else if (this.status === APPOINTMENT_STATUS.NOSHOW) {
        this.markAsNoshow()
      }
    },

    async confirmTerminate(status) {
      if (this.loading) return
      this.loading = true
      try {
        await this.terminateParticipation({
          appointmentId: this.event._id,
          data: {
            customer: this.customerId,
            status,
            processDeposit: this.lateCancel ? DEPOSIT_PROCESS_TYPES.DEPOSIT : DEPOSIT_PROCESS_TYPES.REFUND
          }
        })
        this.$emit('close')
      } catch (err) {
        this.$handleAPIError(err)
      }
      this.loading = false
    },
    markAsNoshow() {
      this.$buefy.dialog.confirm({
        message: this.$t('appointment.noshow_confirm.body'),
        title: this.$t('appointment.noshow_confirm.title'),
        cancelText: this.$t('appointment.noshow_confirm.cancel'),
        confirmText: this.$t('appointment.noshow_confirm.action'),
        type: 'is-danger',
        onConfirm: () => {
          this.confirmTerminate(APPOINTMENT_STATUS.NOSHOW)
        }
      })
    },
    cancelAppointment() {
      this.$buefy.dialog.confirm({
        message: this.$t('appointment.cancel_confirm.body'),
        title: this.$t('appointment.cancel_confirm.title'),
        cancelText: this.$t('misc.no'),
        confirmText: this.$t('misc.yes'),
        type: 'is-danger',
        onConfirm: () => {
          this.confirmTerminate(APPOINTMENT_STATUS.CANCELED)
        }
      })
    }
  }
}
</script>
